import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

export default function Analytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/analytics/overview").then((r) => setData(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="analytics-view">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Analytics & attribution</h1>
        <p className="mt-1 text-sm text-slate-400">Per-campaign, per-persona, per-channel — measured to the booked meeting.</p>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {data && [
          { label: "Reply rate (email)", value: `${data.reply_rate}%` },
          { label: "Positive reply rate", value: `${data.positive_reply_rate}%` },
          { label: "LinkedIn connections", value: "78.95%" },
        ].map((c) => (
          <div key={c.label} className="rounded-2xl border border-white/5 bg-white/[0.02] p-6">
            <div className="text-xs uppercase tracking-widest text-slate-500">{c.label}</div>
            <div className="mt-2 text-4xl font-bold">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-white/5 bg-white/[0.02] p-6">
        <div className="text-sm font-semibold mb-4">Volume trend · last 4 weeks</div>
        {data && (
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data.weekly}>
                <defs>
                  <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#0EA5E9" stopOpacity={0.5} />
                    <stop offset="100%" stopColor="#0EA5E9" stopOpacity={0} />
                  </linearGradient>
                </defs>
                <CartesianGrid stroke="rgba(148,163,184,0.08)" vertical={false} />
                <XAxis dataKey="week" stroke="#64748b" fontSize={12} />
                <YAxis stroke="#64748b" fontSize={12} />
                <Tooltip contentStyle={{ background: "#0B1020", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 12 }} />
                <Area type="monotone" dataKey="sent" stroke="#0EA5E9" fill="url(#g1)" strokeWidth={2} />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        )}
      </div>
    </div>
  );
}
